import React from 'react';
import toTitleCase from './utils';
import types from './assets/types/index.js';
import './styles/PokemonCard.css';


function PokemonCard(props) {
	const { pokemon, detailLevel, animation, noFairyInGame, playerTwoView } = props;
	const irregularNames = ['meowstic-male', 'basculin-red-striped', 'aegislash-shield', 'wormadam-plant', 'gourgeist-average', 'giratina-altered', 'darmanitan-standard', 'tornadus-incarnate', 'landorus-incarnate', 'thundurus-incarnate', 'zygarde-50', 'deoxys-normal', 'oricorio-baile', 'wishiwashi-solo', 'lycanroc-midday', 'mimikyu-disguised', 'minior-red-meteor', 'morpeko-full-belly', 'indeedee-male', 'toxtricity-amped', 'eiscue-ice', 'basculegion-male', 'shaymin-land', 'enamorus-incarnate', 'urshifu-single-strike', 'maushold-family-of-four', 'dudunsparce-three-segment', 'squawkabilly-green-plumage', 'oinkologne-male', 'palafin-zero', 'tatsugiri-curly'];

	const renderTypes = () => {
		if (pokemon.data.types.length > 1) {
			if (noFairyInGame) {
				return (
					<>
						<img className="typeImage" src={types[pokemon.data.types[0].type.name === 'fairy' ? 'normal' : pokemon.data.types[0].type.name]} alt={`A representation of the pokemon type ${pokemon.data.types[0].type.name}`} />
						{(pokemon.data.types[1].type.name !== 'fairy') ? (<img className="typeImage" src={types[pokemon.data.types[1].type.name]} alt={`A representation of the pokemon type ${pokemon.data.types[1].type.name}`} />) : (<div style={{ height: '15px' }}></div>)}
					</>
				)
			} else {
				return (
					<>
					<img className="typeImage" src={types[pokemon.data.types[0].type.name]} alt={`A representation of the pokemon type ${pokemon.data.types[0].type.name}`} />
					<img className="typeImage" src={types[pokemon.data.types[1].type.name]} alt={`A representation of the pokemon type ${pokemon.data.types[1].type.name}`} />
				</>
				)
			}
		} else {
			return (
			<>
				<img className="typeImage" src={types[pokemon.data.types[0].type.name === 'fairy' && noFairyInGame ? 'normal' : pokemon.data.types[0].type.name]} alt={`A representation of the pokemon type ${pokemon.data.types[0].type.name}`} />
				<div style={{ height: '15px' }}></div>
			</>
			)
		}
	}

  return (
		<>
		{/* Basic view */}
		{detailLevel === 'basic' ? (
			<div className="cardBasic" id={pokemon.name} style={{ animation: animation, backgroundColor: playerTwoView && '#c6ade6' }}> {/* might change the color here */}
				<img className="cardImage" crossOrigin="anonymous" src={pokemon.data.sprites?.front_default || 'https://media1.tenor.com/m/Tya2Q6TPVXQAAAAC/slowpoke-thinking.gif'} alt={`The pokemon ${pokemon.name} in their default front sprite`}/>
				<p>{toTitleCase(irregularNames.includes(pokemon.name) ? pokemon.name.split('-')[0] : pokemon.name)}</p>
			</div>
		) : (
			// Detailed view
			<div className="cardDetailed" id={pokemon.name} style={{ animation: animation, backgroundColor: playerTwoView && '#c6ade6' }}> {/* might change the color here */}
			<div className="imageAndType">
				<img className="cardImage" crossOrigin="anonymous" src={pokemon.data.sprites?.front_default || 'https://media1.tenor.com/m/Tya2Q6TPVXQAAAAC/slowpoke-thinking.gif'} alt={`The pokemon ${pokemon.name} in their default front sprite`}/>
				<div className="typesSection">
					{renderTypes()}
				</div>
			</div>
			<section className="detailsArea">
				<span className="noto-sans-bold">{toTitleCase(irregularNames.includes(pokemon.name) ? pokemon.name.split('-')[0] : pokemon.name)}</span>
				<table>
					<tbody>
						{pokemon.data.stats.map(stat => (
							<tr key={stat.stat.name}>
								<td className="statName">{`${toTitleCase(stat.stat.name === 'hp' ? stat.stat.name.toUpperCase() : stat.stat.name)}: `}</td>
								<td className="statValue">{stat.base_stat}</td>
							</tr>
						))}
					</tbody>
				</table>
			</section>
		</div>
		)}
		</>
  );
}

export default PokemonCard;
